import { render, staticRenderFns } from "./RequisitionListFilter.vue?vue&type=template&id=2a04b023&scoped=true&"
import script from "./RequisitionListFilter.vue?vue&type=script&lang=js&"
export * from "./RequisitionListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04b023",
  null
  
)

export default component.exports